import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const QuantityControllerContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 88px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid ${colors.gray200};
  background-color: ${colors.white};

  ${({ disabled }) => disabled && `cursor: not-allowed; opacity: 0.3;`}
`;

export const IconContainer = styled.div<{ direction: 'left' | 'right' }>`
  width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ direction }) =>
    direction === 'left' && 'border-right: 1px solid var(--color-ui-grayscale-gray-200);'}

  ${({ direction }) =>
    direction === 'right' && 'border-left: 1px solid var(--color-ui-grayscale-gray-200);'}
`;
